import type { ComputedVisibilityPayloadType } from '../../types/visibilityPayload';

export type TooltipType = 'text' | 'slot';

export type TooltipPlacementBehavior = 'auto' | 'manual';

export type TooltipPlacementPosition =
  | 'top'
  | 'top-start'
  | 'top-end'
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'left'
  | 'left-start'
  | 'left-end'
  | 'right'
  | 'right-start'
  | 'right-end';

export type BlockTooltipAddOn = {
  type?: TooltipType;
  content?: string;
  placementBehavior?: TooltipPlacementBehavior;
  placementPosition?: TooltipPlacementPosition;
  appearance?: {
    visibility?: ComputedVisibilityPayloadType;
    offset?: number;
  };
};

// tells if this is a legacyTooltip based on the presence of a `type` field
export const isLegacyTooltip = (tooltip: { type?: unknown } | null | undefined): boolean =>
  Boolean(tooltip) && tooltip?.type === undefined;

// default slot name for blocks with a single tooltip addOn
export const TOOLTIP_SLOT_ID = 'tooltip';

// slot name for blocks that own several tooltips under one block (e.g. a ButtonGroup where each
// option has its own tooltip). the prefix is the owning item's id so every slot stays unique.
export const getTooltipSlotId = (prefix: string) => `${prefix}_tooltip`;
